import {register} from '../vendor/theme-scripts/theme-sections';
import {slider, Slider} from '../features/slider';

const selectors = {
  slider: '[data-slider]',
};

const sections = {};

class Blog {
  constructor(section) {
    this.container = section.container;
    this.slideshows = this.container.querySelectorAll(selectors.slider);

    if (this.slideshows.length > 1) {
      this.init();
    }
  }

  init() {
    const [, ...slideshows] = this.slideshows;
    slideshows.forEach((element) => {
      if (element.parentElement) {
        new Slider(element.parentElement);
      }
    });
  }
}

const blogSection = {
  onLoad() {
    sections[this.id] = new Blog(this);
  },
};

register('blog-template', [blogSection, slider]);
